import { NodeCategory } from 'src/containers/ProjectDiagram/constants/categories';
import {
  DeletedModelConceptClass,
  ModelConceptClass,
} from 'src/containers/ProjectDiagram/types/data';

export const replaceDeletedModelConceptClassKey = (key: string) =>
  key.replace(
    new RegExp(`^${NodeCategory.MODEL_CONCEPT_CLASS}-`),
    `${NodeCategory.DELETED_MODEL_CONCEPT_CLASS}-`
  );

export const isDeletedModelConceptClassKey = (key: string) =>
  key.match(new RegExp(`^${NodeCategory.DELETED_MODEL_CONCEPT_CLASS}-`));

export const getDeletedModelConceptClassValue = (key: string) =>
  key.replace(new RegExp(`^${NodeCategory.DELETED_MODEL_CONCEPT_CLASS}-`), '');

export const createDeletedModelConceptClass = (
  existing: ModelConceptClass,
  label: string
): DeletedModelConceptClass => ({
  key: replaceDeletedModelConceptClassKey(existing.key),
  value: existing.value,
  text: label,
  category: NodeCategory.DELETED_MODEL_CONCEPT_CLASS,
  pos: existing.pos,
});
